import { render, staticRenderFns } from "./IntelligenceFishery.vue?vue&type=template&id=c9085da0&"
import script from "./IntelligenceFishery.vue?vue&type=script&lang=js&"
export * from "./IntelligenceFishery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports